export const initialValues: { [key: string]: { [key: string]: any } } = {
  title: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  noOfJobs: {
    value: undefined,
    error: '',
    isTouched: false,
    rules: {
      type: 'number',
      required: true,
    },
  },
};

export const JobClassifications: Array<{ code: string; title: string }> = [
  {
    code: '236115',
    title: 'New Single-Family Housing Construction (except For-Sale Builders)',
  },
  {
    code: '236116',
    title: 'New Multifamily Housing Construction (except For-Sale Builders)',
  },
  { code: '236117', title: 'New Housing For-Sale Builders' },
  { code: '236118', title: 'Residential Remodelers' },
  { code: '236210', title: 'Industrial Building Construction' },
  {
    code: '236220',
    title: 'Commercial and Institutional Building Construction',
  },
  {
    code: '237110',
    title: 'Water and Sewer Line and Related Structures Construction',
  },
  {
    code: '237120',
    title: 'Oil and Gas Pipeline and Related Structures Construction',
  },
  {
    code: '237130',
    title: 'Power and Communication Line and Related Structures Construction',
  },
  { code: '237210', title: 'Land Subdivision' },
  { code: '237310', title: 'Highway, Street, and Bridge Construction' },
  { code: '237990', title: 'Other Heavy and Civil Engineering Construction' },
  {
    code: '238110',
    title: 'Poured Concrete Foundation and Structure Contractors',
  },
  {
    code: '238120',
    title: 'Structural Steel and Precast Concrete Contractors',
  },
  { code: '238130', title: 'Framing Contractors' },
  { code: '238140', title: 'Masonry Contractors' },
  { code: '238150', title: 'Glass and Glazing Contractors' },
  { code: '238160', title: 'Roofing Contractors' },
  { code: '238170', title: 'Siding Contractors' },
  {
    code: '238190',
    title: 'Other Foundation, Structure, and Building Exterior Contractors',
  },
  {
    code: '238210',
    title: 'Electrical Contractors and Other Wiring Installation Contractors',
  },
  {
    code: '238220',
    title: 'Plumbing, Heating, and Air-Conditioning Contractors',
  },
  { code: '238290', title: 'Other Building Equipment Contractors' },
  { code: '238310', title: 'Drywall and Insulation Contractors' },
  { code: '238320', title: 'Painting and Wall Covering Contractors' },
  { code: '238330', title: 'Flooring Contractors' },
  { code: '238340', title: 'Tile and Terrazzo Contractors' },
  { code: '238350', title: 'Finish Carpentry Contractors' },
  { code: '238390', title: 'Other Building Finishing Contractors' },
  { code: '238910', title: 'Site Preparation Contractors' },
  { code: '238990', title: 'All Other Specialty Trade Contractors' },
  { code: '522110', title: 'Commercial Banking' },
  { code: '522291', title: 'Consumer Lending' },
  { code: '522292', title: 'Real Estate Credit' },
  { code: '522298', title: 'All Other Nondepository Credit Intermediation' },
  { code: '522310', title: 'Mortgage and Nonmortgage Loan Brokers' },
  { code: '523110', title: 'Investment Banking and Securities Dealing' },
  { code: '523120', title: 'Securities Brokerage' },
  { code: '523140', title: 'Commodity Contracts Brokerage' },
  { code: '523210', title: 'Securities and Commodity Exchanges' },
  { code: '523910', title: 'Miscellaneous Intermediation' },
  { code: '523920', title: 'Portfolio Management' },
  { code: '523930', title: 'Investment Advice' },
  { code: '523991', title: 'Trust, Fiduciary, and Custody Activities' },
  { code: '523999', title: 'Miscellaneous Financial Investment Activities' },
  { code: '524126', title: 'Direct Property and Casualty Insurance Carriers' },
  { code: '524127', title: 'Direct Title Insurance Carriers' },
  { code: '524130', title: 'Reinsurance Carriers' },
  { code: '524210', title: 'Insurance Agencies and Brokerages' },
  { code: '524291', title: 'Claims Adjusting' },
  {
    code: '524292',
    title: 'Third Party Administration of Insurance and Pension Funds',
  },
  { code: '524298', title: 'All Other Insurance Related Activities' },
  { code: '525110', title: 'Pension Funds' },
  { code: '525910', title: 'Open-End Investment Funds' },
  { code: '525920', title: 'Trusts, Estates, and Agency Accounts' },
  { code: '525990', title: 'Other Financial Vehicles' },
  { code: '531110', title: 'Lessors of Residential Buildings and Dwellings' },
  {
    code: '531120',
    title: 'Lessors of Nonresidential Buildings (except Miniwarehouses)',
  },
  { code: '531130', title: 'Lessors of Miniwarehouses and Self-Storage Units' },
  { code: '531190', title: 'Lessors of Other Real Estate Property' },
  { code: '531210', title: 'Offices of Real Estate Agents and Brokers' },
  { code: '531311', title: 'Residential Property Managers' },
  { code: '531312', title: 'Nonresidential Property Managers' },
  { code: '531320', title: 'Offices of Real Estate Appraisers' },
  { code: '531390', title: 'Other Activities Related to Real Estate' },
  {
    code: '532120',
    title:
      'Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing',
  },
  { code: '532210', title: 'Consumer Electronics and Appliances Rental' },
  { code: '532281', title: 'Formal Wear and Costume Rental' },
  { code: '532289', title: 'All Other Consumer Goods Rental' },
  { code: '532310', title: 'General Rental Center' },
  {
    code: '532411',
    title:
      'Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing',
  },
  {
    code: '532412',
    title:
      'Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing',
  },
  {
    code: '532420',
    title: 'Office Machinery and Equipment Rental and Leasing',
  },
  {
    code: '532490',
    title:
      'Other Commercial and Industrial Machinery and Equipment Rental and Leasing',
  },
  { code: '541110', title: 'Offices of Lawyers' },
  { code: '541120', title: 'Offices of Notaries' },
  { code: '541191', title: 'Title Abstract and Settlement Offices' },
  { code: '541199', title: 'All Other Legal Services' },
  { code: '541211', title: 'Offices of Certified Public Accountants' },
  { code: '541213', title: 'Tax Preparation Services' },
  { code: '541214', title: 'Payroll Services' },
  { code: '541219', title: 'Other Accounting Services' },
  { code: '541310', title: 'Architectural Services' },
  { code: '541320', title: 'Landscape Architectural Services' },
  { code: '541330', title: 'Engineering Services' },
  { code: '541340', title: 'Drafting Services' },
  { code: '541350', title: 'Building Inspection Services' },
  { code: '541360', title: 'Geophysical Surveying and Mapping Services' },
  {
    code: '541370',
    title: 'Surveying and Mapping (except Geophysical) Services',
  },
  { code: '541380', title: 'Testing Laboratories' },
  { code: '541410', title: 'Interior Design Services' },
  { code: '541420', title: 'Industrial Design Services' },
  { code: '541430', title: 'Graphic Design Services' },
  { code: '541490', title: 'Other Specialized Design Services' },
  { code: '541511', title: 'Custom Computer Programming Services' },
  { code: '541512', title: 'Computer Systems Design Services' },
  { code: '541513', title: 'Computer Facilities Management Services' },
  { code: '541519', title: 'Other Computer Related Services' },
  {
    code: '541611',
    title:
      'Administrative Management and General Management Consulting Services',
  },
  { code: '541612', title: 'Human Resources Consulting Services' },
  { code: '541613', title: 'Marketing Consulting Services' },
  {
    code: '541614',
    title: 'Process, Physical Distribution, and Logistics Consulting Services',
  },
  { code: '541618', title: 'Other Management Consulting Services' },
  { code: '541620', title: 'Environmental Consulting Services' },
  {
    code: '541690',
    title: 'Other Scientific and Technical Consulting Services',
  },
  { code: '541810', title: 'Advertising Agencies' },
  { code: '541820', title: 'Public Relations Agencies' },
  { code: '541830', title: 'Media Buying Agencies' },
  { code: '541840', title: 'Media Representatives' },
  { code: '541850', title: 'Outdoor Advertising' },
  { code: '541860', title: 'Direct Mail Advertising' },
  { code: '541870', title: 'Advertising Material Distribution Services' },
  { code: '541890', title: 'Other Services Related to Advertising' },
  { code: '541910', title: 'Marketing Research and Public Opinion Polling' },
  { code: '541921', title: 'Photography Studios, Portrait' },
  { code: '541922', title: 'Commercial Photography' },
  { code: '541930', title: 'Translation and Interpretation Services' },
  {
    code: '541990',
    title: 'All Other Professional, Scientific, and Technical Services',
  },
  { code: '561110', title: 'Office Administrative Services' },
  { code: '561311', title: 'Employment Placement Agencies' },
  { code: '561210', title: 'Facilities Support Services' },
  { code: '721120', title: 'Casino Hotels' },
  { code: '721110', title: 'Hotels (except Casino Hotels) and Motels' },
  { code: '721199', title: 'All Other Traveler Accommodation' },
  { code: '721191', title: 'Bed-and-Breakfast Inns)' },
  {
    code: '721310',
    title: "Rooming and Boarding Houses, Dormitories, and Workers' Camps",
  },
  { code: '721211', title: 'RV (Recreational Vehicle) Parks and Campgrounds' },
  { code: '722320', title: 'Caterers' },
  { code: '722310', title: 'Food Service Contractors' },
  { code: '722511', title: 'Full-Service Restaurants' },
  { code: '722330', title: 'Mobile Food Services' },
  { code: '722513', title: 'Limited-Service Restaurants' },
];

